import script from "./ImageCropper.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageCropper.vue?vue&type=script&setup=true&lang=js"

import "./ImageCropper.vue?vue&type=style&index=0&id=04d2d719&lang=css"

const __exports__ = script;

export default __exports__